<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('ordine_storico')}}</h1></div>
            <div class="content content-full">
                <div class="title">{{$t('ordini_effettuati')}}</div>

                <div class="container">
                    <div class="row-sezione">
                        <div class="text-center my-5" v-if="this.loading">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else-if="this.orders.length">
                            <div class="blocchetto p-0" style="margin-bottom: 0;" v-for="order in this.orders">
                              <div class="d-flex justify-content-between">
                                <router-link :to="{name:'orders.details', params:{id:order.id}}" class="flex-grow-1 a1 p-2">
                                  {{$t('carrello_ordine_label').capitalize()}} n°: {{order.id}} - <inc-order-status :status="order.status"/>
                                  <br>
                                  <b>
                                    <inc-order-type :type="order.tipo_ordine"/><br>
                                    <inc-order-datetime :datetime-delivery-takeaway="order.data_ora_consegna_ritiro"
                                                        :delivery-takeaway-end-slot="order.consegna_ritiro_fine_fascia"
                                                        :language="language"/>
                                  </b>
                                  <br>
                                  <div v-if="order.tipo_racer === 'GLOVO'">
                                    <img height="20" src="/img/be/glovo-status.png" alt="glovo"/>
                                    <span class="ml-1">{{ getGlovoStatus(order.status_spedizione) }}</span>

                                    <div v-if="order.nominativo_corriere_spedizione || order.telefono_corriere_spedizione">
                                      <span>{{ getGlovoCourier(order.nominativo_corriere_spedizione, order.telefono_corriere_spedizione) }}</span>
                                    </div>
                                  </div>
                                  {{$t('ordini_pagamento')}}:
                                  <inc-order-payment-mode
                                      :payment-mode="order.modalita_pagamento"
                                      :payment-preference="order.preferenza_pagamento"
                                      :order-type="order.tipo_ordine"
                                  />
                                  <br>
                                  <span class="color">
                                    <b>{{$t('totale')}}:  {{order.totale_ordine.toFixedGood(2)}} {{locale_currency}}</b>
                                </span>
                                </router-link>

                                  <div class="d-flex flex-column">
                                    <a href="#" @click.prevent="openMessagingModal(order)" class="link-modal-messaggeria h-100" v-if="order.tipo_ordine !== 'ORDINA_TAVOLO' && !!order.chat_visible">
                                      <div class="d-flex align-items-center bg-color-dark my-0 h-100" style="padding: 6px;">
                                          <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('messaggistica')">
                                        mark_as_unread
                                        </span>
                                        <span class="badge badge-info" v-if="getConversationMsgCounter(order)">
                                            {{getConversationMsgCounter(order)}}</span>
                                      </div>
                                    </a>
                                    <a href="#" @click.prevent="openFeedbackModal(order)" class="link-modal-messaggeria h-100" v-if="!!order.feedback_enabled">
                                      <div class="d-flex align-items-center bg-color-dark my-0 h-100" style="padding: 6px;">
                                      <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('feedback')">
                                        star_rate
                                      </span>
                                      </div>
                                    </a>
                                    <router-link :to="{name:'orders', query:{reorder_order_id: order.id}}" class="h-100">
                                      <div class="d-flex align-items-center bg-color my-0 h-100" style="padding: 6px;">
                                      <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('riordina')">
                                        add_shopping_cart
                                      </span>
                                      </div>
                                    </router-link>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <p class="text-center f14" style="margin-top: 30px;" v-else>
                            {{$t('nessun_ordine')}}
                        </p>
                    </div>
                </div>

                <div class="container d-none d-md-block">
                  <hr>
                    <div class="row-sezione d-flex justify-content-center">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                    </div>
                </div>
            </div>
        </div>
        <modal-messaging v-if="this.show_modal" @close="show_modal = false"
                         type="ORDINE"
                         :item="this.selected_order"
        />
      <modal-feedback v-if="this.show_feedback_modal" @close="show_feedback_modal = false"
                       type="ORDINE"
                       :item="this.selected_order"
      />
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {getOrderHistory} from '../../api/account';
import { getGlovoStatus, getGlovoCourier } from "../../libraries/utils";

import IncOrderType from "./partials/IncOrderType";
import IncOrderDatetime from "./partials/IncOrderDatetime";
import IncOrderStatus from "./partials/IncOrderStatus";
import IncOrderPaymentMode from "./partials/IncOrderPaymentMode";
import ModalMessaging from "../messaging/partials/ModalMessaging";
import ModalFeedback from "./partials/ModalFeedback.vue";

export default {
    name: "History",
    components: {ModalMessaging, ModalFeedback, IncOrderPaymentMode, IncOrderStatus, IncOrderDatetime, IncOrderType},
    data() {
        return {
            orders: [],
            loading: false,

            show_modal: false,
            show_feedback_modal: false,
            selected_order: null
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        }),
        ...mapGetters('chat', {
            getMsgCounterFromId: 'getMsgCounterFromId'
        })
    },
    methods: {
        fetch: function () {
            this.loading = true;
            this.showLoading(true);
            getOrderHistory(this.language, {
                id_ristorante: this.id_ristorante,
                api_key: this.user.api_key,
                counter_messaggi: false
            }).then((response) => {
                this.orders = response.ordini;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.loading = false;
                this.showLoading(false);
            });
        },
        openMessagingModal: function (order) {
            this.selected_order = order;
            this.show_modal = true;
        },
        getConversationMsgCounter: function (order) {
            try {
                return this.getMsgCounterFromId(order.chat.id);
            } catch (e) {
                return null
            }
        },
      openFeedbackModal: function (order) {
        this.selected_order = order;
        this.show_feedback_modal = true;
      },
        getGlovoStatus,
        getGlovoCourier,
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
